module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap personal-wrap flex-column"
  }, [_c('div', {
    staticClass: "flex-this.currentAddress"
  }, [_c('ul', {
    staticClass: "edit editaddress"
  }, [_c('li', {
    staticClass: "user-order-title"
  }, [_c('p', [_c('label', [_vm._v("收货人")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentAddress.consignee),
      expression: "currentAddress.consignee"
    }],
    staticClass: "right ellipsis",
    attrs: {
      "type": "text",
      "placeholder": "姓名",
      "maxlength": "32"
    },
    domProps: {
      "value": (_vm.currentAddress.consignee)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentAddress, "consignee", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "user-order-title"
  }, [_c('p', [_c('label', [_vm._v("联系电话")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentAddress.mobile),
      expression: "currentAddress.mobile"
    }],
    staticClass: "right ellipsis",
    attrs: {
      "placeholder": "手机号码",
      "type": "number",
      "minlength": "11",
      "maxlength": "11"
    },
    domProps: {
      "value": (_vm.currentAddress.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentAddress, "mobile", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "user-order-title",
    on: {
      "click": function($event) {
        _vm.bottomPopup = true
      }
    }
  }, [_c('p', [_c('label', [_vm._v("所在地区")]), _vm._v(" "), _c('input', {
    staticClass: "right ellipsis",
    attrs: {
      "placeholder": "请选择省市区县",
      "readonly": "",
      "type": "text",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.addressMsgShow
    }
  })]), _vm._v(" "), _c('img', {
    staticClass: "user-right",
    attrs: {
      "src": "/static/images/ic_more_3x.png"
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "user-order-title"
  }, [_c('p', [_c('label', [_vm._v("详细地址")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentAddress.address),
      expression: "currentAddress.address"
    }],
    staticClass: "right ellipsis",
    attrs: {
      "placeholder": "详细地址需填写楼栋楼层或房间号信息"
    },
    domProps: {
      "value": (_vm.currentAddress.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentAddress, "address", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "user-order-title"
  }, [_c('p', [_c('label', [_vm._v("邮政编码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentAddress.postCode),
      expression: "currentAddress.postCode"
    }],
    staticClass: "right ellipsis",
    attrs: {
      "placeholder": "选填，若您不清楚邮递区号，请填000000",
      "type": "text",
      "maxlength": "6"
    },
    domProps: {
      "value": (_vm.currentAddress.postCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentAddress, "postCode", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', [_c('mu-popup', {
    attrs: {
      "position": "bottom",
      "popupClass": "demo-popup-bottom popup-bottom physical-popup",
      "open": _vm.bottomPopup
    },
    on: {
      "close": function($event) {
        _vm.bottomPopup = false
      }
    }
  }, [_c('h3', [_vm._v("所在地区"), _c('span', {
    on: {
      "click": function($event) {
        _vm.bottomPopup = false
      }
    }
  })]), _vm._v(" "), _c('mu-content-block', [(_vm.chooseBox) ? _c('div', {
    staticClass: "chooseList forbid-sel-text",
    class: {
      'chooseTwo': _vm.shoWOr == 2,
      'chooseOne': _vm.shoWOr == 1
    }
  }, [_c('div', {
    staticClass: "pShow"
  }, [(_vm.shoWOr <= 1) ? _c('samp', {
    staticClass: "sampOne",
    on: {
      "click": function($event) {
        return _vm.clickProvince(1)
      }
    }
  }, [_vm._v("请选择")]) : _vm._e(), _vm._v(" "), (_vm.shoWOr >= 2) ? _c('samp', {
    on: {
      "click": function($event) {
        return _vm.clickProvince(2)
      }
    }
  }, [_vm._v(_vm._s(_vm.addressProvince))]) : _vm._e(), _vm._v(" "), (_vm.shoWOr >= 3) ? _c('samp', {
    on: {
      "click": function($event) {
        return _vm.clickProvince(2)
      }
    }
  }, [_vm._v(_vm._s(_vm.cityNameShow))]) : _vm._e(), _vm._v(" "), (_vm.shoWOr == 2) ? _c('samp', {
    staticClass: "sampTwo"
  }, [_vm._v("请选择")]) : _vm._e()]), _vm._v(" "), (_vm.shoWOr == 1) ? _c('div', {
    staticClass: "chooseProvince"
  }, _vm._l((_vm.arealistMsg), function(provinceShow) {
    return _c('span', {
      on: {
        "click": function($event) {
          return _vm.shooseProvince(provinceShow.areaId, provinceShow.areaName)
        }
      }
    }, [_vm._v(_vm._s(provinceShow.areaName))])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.shoWOr == 2) ? _c('div', {
    staticClass: "chooseProvince"
  }, _vm._l((_vm.cityListShow), function(cityShow) {
    return _c('span', {
      class: {
        'chooseCityStyle': _vm.chooseCityId == cityShow.areaId
      },
      on: {
        "click": function($event) {
          return _vm.shooseCity(cityShow.areaId, cityShow.areaName)
        }
      }
    }, [_vm._v(" " + _vm._s(cityShow.areaName))])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.shoWOr == 3) ? _c('div', {
    staticClass: "chooseProvince"
  }, _vm._l((_vm.areaAddressMsg), function(areaListShow) {
    return _c('span', {
      class: {
        'chooseCityStyle': _vm.chooseAreaId == areaListShow.areaId
      },
      on: {
        "click": function($event) {
          return _vm.shooseArea(areaListShow.areaId, areaListShow.areaName)
        }
      }
    }, [_vm._v(" " + _vm._s(areaListShow.areaName))])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.shoWOr == 4) ? _c('div', {
    staticClass: "chooseProvince"
  }, _vm._l((_vm.getStreetMsgList), function(streetListShow) {
    return _c('span', {
      class: {
        'chooseCityStyle': _vm.chooseStreetId == streetListShow.areaId
      },
      on: {
        "click": function($event) {
          return _vm.shooseStreet(streetListShow.areaId, streetListShow.areaName)
        }
      }
    }, [_vm._v(" " + _vm._s(streetListShow.areaName))])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bottom-btn-box"
  }, [_c('div', {
    staticClass: "bottom-full-button"
  }, [_c('mu-raised-button', {
    attrs: {
      "label": "确认",
      "fullWidth": "",
      "primary": ""
    },
    on: {
      "click": function($event) {
        _vm.bottomPopup = false
      }
    }
  })], 1)])]) : _vm._e()])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "editButton"
  }, [_c('mu-raised-button', {
    attrs: {
      "label": "保存",
      "fullWidth": "",
      "primary": ""
    },
    on: {
      "click": _vm.save
    }
  })], 1)]), _vm._v(" "), (_vm.errorShow == 1) ? _c('mu-toast', {
    staticClass: "custom-toast",
    attrs: {
      "message": "请核对您输入的信息!"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.toast2) ? _c('mu-toast', {
    staticClass: "custom-toast",
    attrs: {
      "message": _vm.messageShow
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e98109b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/personal/writeaddress.vue
// module id = 394
// module chunks = 68